import { HTTPError } from "ky";

/** True when the API refused the request because the user's role lacks a permission. */
export function isPermissionDeniedError(error: unknown): boolean {
  return error instanceof HTTPError && error.response.status === 403;
}

export interface PermissionDeniedToast {
  id: string;
  title: string;
  description: string;
  variant: "error";
}

/**
 * Shown when a photo upload is refused for permissions. Retaking won't help, so
 * it says who can fix it. The fixed id collapses a burst of refused shots into
 * one toast.
 */
export const PHOTO_PERMISSION_DENIED_TOAST: PermissionDeniedToast = {
  id: "photo-permission-denied",
  title: "You don't have permission to add photos",
  description:
    "Ask a clinic admin to give your role the Add Photos permission, then take the photos again.",
  variant: "error",
};

/** For camera saves that aren't gallery photos (a profile photo, a form answer). */
export const SAVE_PERMISSION_DENIED_TOAST: PermissionDeniedToast = {
  id: "camera-permission-denied",
  title: "You don't have permission to save this photo",
  description: "Ask a clinic admin to check your role's permissions.",
  variant: "error",
};

/** Shown when the API refuses to delete a photo because the role lacks note write. */
export const PHOTO_DELETE_PERMISSION_DENIED_TOAST: PermissionDeniedToast = {
  id: "photo-delete-permission-denied",
  title: "You don't have permission to delete photos",
  description: "Ask a clinic admin to check your role's permissions.",
  variant: "error",
};
